export default __webpack_public_path__ + "static/media/archive.539620f8.svg";